import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index";

export const getCustomerKonten = async () => {
    try {
        const response = await axios.get('/customer/konten/getKonten')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const addCustomerKonten = async (payload) => {
    try {
        const response = await axios.post('/customer/konten/createKonten', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerKonten = async (payload) => {
    try {
        const response = await axios.put('/customer/konten/updateKonten', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteCustomerKonten = async (payload) => {
    try {
        const response = await axios.put('/customer/konten/deleteKonten', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const getCustomerDarlehen = async () => {
    try {
        const response = await axios.get('/customer/konten/getDarlehen')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const addCustomerDarlehen = async (payload) => {
    try {
        const response = await axios.post('/customer/konten/createDarlehen', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerDarlehen = async (payload) => {
    try {
        const response = await axios.put('/customer/konten/updateDarlehen', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteCustomerDarlehen = async (payload) => {
    try {
        const response = await axios.put('/customer/konten/deleteDarlehen', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}
